import { Portal } from 'react-portal';
import { AddTagsContent } from 'components/Dashboard/Influence/CrmContacts/AddTagsModal/AddTagsModal';
import useAddTagsToStakeholder from 'components/Dashboard/StakeHolders/StakeholderPage/useAddTagsToStakeholder';
import useContactsFunctionForStakeholders from 'components/Dashboard/StakeHolders/StakeholderPage/useContactsFunctionForStakeholder';
import useTopicOrClientWord from 'components/Dashboard/hooks/useTopicOrClientWord';
import { useContext } from 'react';
import { store } from 'components/Store';
import ModalComponent from 'components/Common/Modal';

const ContentPopup = (props) => {
  const { setShowPopup, StakeholderInformation, customContact } = props;
  const { tags, setTags, isLoading, addTagsToStakeholder } = useAddTagsToStakeholder({ customContact });

  return (
    <div className='pt-4'>
      <AddTagsContent
        titleText={StakeholderInformation?.officalName ?? StakeholderInformation?.title}
        tags={tags}
        setTags={setTags}
        isLoading={isLoading}
        addTagsToContacts={addTagsToStakeholder}
        closeModal={() => setShowPopup(false)}
        contactsCount={1}
        autofocus
        searchIcon
      />
    </div>
  );
};

const StakeholderTagsPopup = (props) => {
  const { showPopUp, setShowPopup } = props;
  return (
    <Portal>
      <ModalComponent isOpen={showPopUp} setIsOpen={setShowPopup}>
        <ContentPopup {...props} />
      </ModalComponent>
    </Portal>
  );
};

const ContentStakeholderTagsAddContactPopup = (props) => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { team } = state;

  const { StakeholderInformation, setShowPopup } = props;
  const { addOrDeleteContact } = useContactsFunctionForStakeholders();

  const { newAgencyPlan } = useTopicOrClientWord();

  return (
    <div className='pt-5 pb-4 text-center'>
      <p className='pt-2'>Add this contact to your contact list to tag them</p>
      <button
        onClick={async (e) => {
          await addOrDeleteContact({
            e,
            contactId: StakeholderInformation?.id,
            callback: () => setShowPopup(false),
          });
          setShowPopup(false);
        }}
        className='general-button action-button general-spacing-button px-4 mb-3'
      >
        {newAgencyPlan ? `Add to contact list for ${team?.teamName}` : 'Add to my contacts'}
      </button>
    </div>
  );
};

const StakeholderTagsAddContactPopup = (props) => {
  const { showPopUp, setShowPopup } = props;
  return (
    <Portal>
      <ModalComponent maxWidth={450} isOpen={showPopUp} setIsOpen={setShowPopup}>
        <ContentStakeholderTagsAddContactPopup {...props} />
      </ModalComponent>
    </Portal>
  );
};
export { StakeholderTagsAddContactPopup };
export default StakeholderTagsPopup;
